// ⬡B:msria-home.main:ENTRY:react_root_browser_router_ham_provider:20260604⬡
import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { HamProvider } from '@aba/ham-core';
import App from './App.jsx';

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <BrowserRouter>
      <HamProvider>
        <App />
      </HamProvider>
    </BrowserRouter>
  </React.StrictMode>
);
